export default __webpack_public_path__ + "static/bcom-logo-3579c81478ac342f6a0d04e973acb41f.png";